/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from "react";
import styled from "@emotion/styled";
import { colors, Title1 } from "@utils/ui_palette";
import { rgba } from "emotion-rgba";

interface IModule {
  id: number;
  question: string;
  anwser: string;
  choice: string[] | null;
  question_image: null | string;
  score: number;
  answer_submit: string;
  answer_s3: string;
  answer_id: string;
}

interface IModal {
  item: IModule | null;
  type: string | null;
  callback: (item: IModule, type: string, answer: string | number) => void;
  handleModal: (state: boolean) => void;
}

function ImageModal({ item, type, callback, handleModal }: IModal) {
  const closeModal = useCallback(() => {
    handleModal(false);
  }, []);

  const handleSubmit = useCallback(() => {
    if (item && type) {
      closeModal();
      callback(item, type, item.anwser);
    }
  }, []);

  return (
    <Modals>
      <ModalBody>
        {item && type && (
          <>
            <Title1>{type}</Title1>
            <Contents>
              <ContentsBox>
                <Title1>{item.answer_submit}</Title1>
              </ContentsBox>
            </Contents>
          </>
        )}
        {item && type && (
          <ButtonGroup>
            <ConfirmButton
              onClick={handleSubmit}
              active={
                item.answer_submit === ""
                  ? false
                  : item.anwser.toLowerCase() ===
                    item.answer_submit.toLowerCase()
              }
              disabled={
                item.answer_submit === ""
                  ? false
                  : item.anwser.toLowerCase() ===
                    item.answer_submit.toLowerCase()
              }
            >
              정답처리
            </ConfirmButton>
            <CancelButton onClick={closeModal}>취소</CancelButton>
          </ButtonGroup>
        )}
      </ModalBody>
    </Modals>
  );
}

const Modals = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: ${rgba(colors.Black, 0.5)};
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  width: 900px;
  padding: 30px;
  background-color: ${colors.White};
  border-radius: 15px;
`;

const Contents = styled.div`
  margin-top: 50px;
`;

const ContentsBox = styled.div`
  flex-basis: calc(50% - 20px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 80px;
`;

const ConfirmButton = styled.button<{ active: boolean }>`
  flex-basis: calc(50% - 10px);
  height: 50px;
  outline: 0;
  border: 0;
  background-color: ${(props) =>
    props.active ? colors.Gray30 : colors.Primary50};
  border-radius: 8px;
  color: ${colors.White};
  cursor: ${(props) => (props.active ? "not-allowed" : "pointer")};
`;

const CancelButton = styled.button`
  flex-basis: calc(50% - 10px);
  height: 50px;
  outline: 0;
  border: 1px solid ${colors.Black};
  background-color: ${colors.White};
  border-radius: 8px;
  color: ${colors.Black};
  cursor: pointer;
`;

export default ImageModal;
